import React from "react";
import Wildlife from "../../../../assets/Icons/books/empty_card_placeholder-01 1.svg";

const STATUS_COUNT_KEY = {
  PENDING: "pendingCount",
  APPROVED: "approvedCount",
  REJECTED: "rejectedCount",
};

export const TaskVerificationBookCard = ({ book, status, onSelect }) => {
  const countKey = STATUS_COUNT_KEY[status] || "pendingCount";
  const taskCount = book?.[countKey] ?? 0;

  return (
    <button
      type="button"
      className="taskVerificationBookCard"
      onClick={() => onSelect(book._id)}
    >
      <div className="taskVerificationBookCard__cover">
        <img src={book?.coverImage || Wildlife} alt={book?.name || "Book"} />
        <span className="taskVerificationBookCard__badge">{taskCount}</span>
      </div>
      <p className="taskVerificationBookCard__name">{book?.name}</p>
    </button>
  );
};

export const getBookTaskCountForStatus = (book, status) => {
  const countKey = STATUS_COUNT_KEY[status];
  return countKey ? book?.[countKey] ?? 0 : 0;
};
